export const getCadenceAnalyticsSummarize = {
  GET_CADENCE_ANALYTICS_SUMMARIZE_REQUEST: "GET_CADENCE_ANALYTICS_SUMMARIZE_REQUEST",
  GET_CADENCE_ANALYTICS_SUMMARIZE_SUCCESS: "GET_CADENCE_ANALYTICS_SUMMARIZE_SUCCESS",
  GET_CADENCE_ANALYTICS_SUMMARIZE_ERROR: "GET_CADENCE_ANALYTICS_SUMMARIZE_ERROR",
};
